'use client';

import React from 'react';

// import { usePagination } from '@ajna/pagination';
import { HStack, VStack } from '@chakra-ui/react';

import AppliedExpertise from '../sections/AppliedExpertise';
import DomainTabs from '../sections/DomainTabs';
import Mentors from '../sections/Mentors';
import SearchBar from '../sections/SearchBar';

const FindMentorView = () => (
    <HStack py={5} align="flex-start" justify="space-between" width="100%">
        <VStack gap={5} minW={{ base: '100%', xl: '94vw' }} align="flex-start">
            <DomainTabs />
            <SearchBar />
            <AppliedExpertise />
            <Mentors />
        </VStack>
    </HStack>
);

export default FindMentorView;
